import browser from '@core/util/browser';
import globals from '@core/util/globals';
import constants from '../utils/constants';
import { isMcom } from '../utils/utils';

let pagePixelIndex = 0;
const pixelHostGlobal = globals?.getValue('pixelHost') || constants.ASSETS.MACYS;
const pathToPixelGlobal = '/navapp/img/spacer.gif';
const oopsConfig = {
  pathToPixel: '/web20/assets/img/oopsTracker/oopsTracker.gif',
  pixelHost: isMcom() ? constants.ASSETS.MACYS : constants.ASSETS.BLOOMINGDALES,
};

export const track = (querystring, options = {}) => {
  const {
    append = false,
    pathToPixel = pathToPixelGlobal,
    pixelHost = pixelHostGlobal,
  } = options;

  const i = document.createElement('img');
  // eslint-disable-next-line no-plusplus
  i.id = `trk${pagePixelIndex++}`;
  i.className = 'no-stretch';
  i.width = 1;
  i.height = 1;
  i.src = `${pixelHost + pathToPixel}?${querystring}`;

  if (append) {
    document.body.appendChild(i);
  }

  return true;
};

export const queryBuilder = (options = {}) => {
  const { browser: br, browserVersion: brV } = browser.get();
  const queryOpt = {
    locationUrl: document?.location?.href,
    referrer: document?.referrer || '-',
    OS: navigator?.platform,
    browserNameAndVersion: `${br}And${brV}`,
    ...options,
  };

  return `&${new URLSearchParams(queryOpt).toString()}`;
};

export const oopsTracker = (queryOptions, configOptions = oopsConfig) => {
  const queryOpt = queryBuilder(queryOptions);
  return track(queryOpt, configOptions);
};
